'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of written plan mobile
 */ const WrittenPlanMobile = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "51.926",
                cy: "51.9921",
                rx: "51.926",
                ry: "51.9921",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.9531",
                y: "68.7734",
                width: "17.5725",
                height: "5.17474",
                rx: "1.61163",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.4525 19.0898H62.9165C64.5484 19.0988 66.1107 19.7466 67.2631 20.8921C68.4155 22.0376 69.0646 23.5881 69.0691 25.2058V78.5594C69.0646 80.1801 68.4131 81.7331 67.257 82.8791C66.1009 84.0251 64.5343 84.671 62.8993 84.6754H40.4354C38.8005 84.671 37.2338 84.0251 36.0777 82.8791C34.9216 81.7331 34.2701 80.1801 34.2656 78.5594V66.8244V59.2717V57.4168V25.2058C34.2702 23.5822 34.924 22.0266 36.0838 20.8801C37.2436 19.7337 38.8146 19.0898 40.4525 19.0898Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.2949 68.8496H45.0727C43.6648 68.8496 42.5234 69.981 42.5234 71.3767C42.5234 72.7724 43.6648 73.9038 45.0727 73.9038H58.2949C59.7028 73.9038 60.8442 72.7724 60.8442 71.3767C60.8442 69.981 59.7028 68.8496 58.2949 68.8496Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.7734",
                y: "73.7969",
                width: "6.03913",
                height: "5.91244",
                rx: "2.95622",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.8359",
                y: "22.0898",
                width: "30",
                height: "48",
                rx: "1.97644",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.9922",
                y: "31.6641",
                width: "17.7602",
                height: "1.20561",
                rx: "0.602807",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.9922",
                y: "48.543",
                width: "17.7602",
                height: "1.20561",
                rx: "0.602807",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.9922",
                y: "35.8828",
                width: "9.93367",
                height: "1.20561",
                rx: "0.602807",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.9922",
                y: "56.0781",
                width: "9.93367",
                height: "1.20561",
                rx: "0.602807",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.9922",
                y: "45.8379",
                width: "14.148",
                height: "1.20561",
                rx: "0.602807",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "41.9922",
                y: "59.3984",
                width: "14.148",
                height: "1.20561",
                rx: "0.602807",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.WrittenPlanMobile = WrittenPlanMobile;
//# sourceMappingURL=WrittenPlanMobile.cjs.map
